import { useState } from 'react'
import type { MouseEvent } from 'react'
import { Avatar, AvatarGroup, Popover } from '@mui/material'
import type { Integration } from 'pages/datasets/types'
import * as css from './styles'
import { t } from '@lingui/core/macro'

interface Props {
  data: Integration[]
}

export const createSrc = (integrationSlug: Integration): string => {
  return `https://claravine-public-prod.s3-us-west-2.amazonaws.com/images/${integrationSlug}.png`
}

export const Integrations = ({ data }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const maxShown = 4
  const count = data.length
  const open = Boolean(anchorEl)

  const integrationIcons = data.map((slug, slugIndex) => (
    <Avatar key={`${slug}-${slugIndex}`} alt={slug} src={createSrc(slug)} />
  ))

  return (
    <css.MetaDetail>
      <AvatarGroup
        max={maxShown}
        css={[css.integrations, count > maxShown && [css.grayBg, css.hoverable]]}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {integrationIcons}
      </AvatarGroup>
      <Popover
        id="integrations-popover"
        sx={{ pointerEvents: 'none' }}
        css={css.PopoverStyles}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 25,
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <div>
          <AvatarGroup css={css.integrations} spacing={0} style={{ padding: '5px 6px' }}>
            {integrationIcons}
          </AvatarGroup>
          <css.PopoverTitle>
            {data.length} {data.length === 1 ? t` Integration` : t` Integrations`}
          </css.PopoverTitle>
        </div>
      </Popover>
    </css.MetaDetail>
  )

  function handlePopoverOpen(event: MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget)
  }

  function handlePopoverClose() {
    setAnchorEl(null)
  }
}
